export const formatPersonName = ({ firstname, lastname }: Readonly<{ firstname: string | null; lastname: string | null }>): string | null =>
    [firstname, lastname].filter(Boolean).join(' ') || null;
